export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crypto ID:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Idioma"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buen día"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buenas tardes"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buenas noches"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buenas noches"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cerrar sesión"])}
}